import { _GROUPS } from "@/store/_PERMISSIONS"

// -- FIELDS
const _FIELDS = [
  {
    label: "Brigada",
    name: "id_brigada",
    type: "array",
    store: "brigada",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required"]
  },
  {
    label: "Dádiva",
    name: "id_dadiva",
    type: "array",
    store: "dadiva",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: ["required"]
  },
  {
    title: "Data",
    type: "data",
    name: "data",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: ["required"]
  },
  {
    type: "dcl",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required"]
  },
  {
    label: "Morada",
    name: "morada",
    type: "text",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required"]
  },
  {
    label: "OBS",
    name: "obs",
    type: "textarea",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rows: 3,
    rules: []
  }
]

// -- HEADERS
const _HEADERS = [
  {
    text: "Brigada",
    align: "left",
    value: "brigada"
  },
  {
    text: "Dádiva",
    align: "left",
    value: "dadiva"
  },
  {
    text: "Data",
    align: "left",
    value: "data"
  },
  {
    text: "Ações",
    value: "action"
  }
]

const COLHEITA = {
  _FIELDS: _FIELDS,
  _HEADERS: _HEADERS
}

export default COLHEITA
